// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { chooseSingular } from '../../../../../../../common/utils/stringUtil';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';
import ViewedBoardTitleSummary from './ViewedBoardTitleSummary';

const NotificationEntryGroupedBoardView = (props) => {
    const { actors } = props;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryGroupedBoardView"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-viewed" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> {chooseSingular(actors.length, 'has ', 'have')} seen your changes in:
                <ViewedBoardTitleSummary {...props} />
            </div>
        </BaseNotificationEntry>
    );
};

NotificationEntryGroupedBoardView.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryGroupedBoardView;
